import React from 'react';
import classnames from 'classnames';
import blueLogo from 'assets/images/static/logo-blue.png';
import styles from './header.module.scss';
import urls from 'src/utils/urls';
import {useSelector} from 'react-redux';
import {Store} from 'src/types/store';

const PartnerLogoHeader = () => {
  const student = useSelector((state: Store) => state.student);
  const college = useSelector((state: Store) => state.college);

  return (
    <div className={classnames(styles.wrapper, 'header-wrapper')}>
      <div className={classnames(styles.container, 'nav-bar')}>
        <div className={styles.logos}>
          <img
            className={styles.collegeLogo}
            src={college?.logo}
            alt={student?.currentInstitution?.name}
          />
          <img className={styles.raiseMeLogo} src={blueLogo} alt="Raise Me" />
        </div>
        <a href={urls.logout}>Sign Out</a>
      </div>
    </div>
  );
};

export default PartnerLogoHeader;
